<template>
  <div class="modal-window medium active">
    <overlay-scrollbars :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
      <form @submit.prevent="handleSubmit">

        <div class="modal-window-header gray">
          <div class="modal-window-heading">
            <h3 class="icon-heading small">
              <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-object"></use></svg></span>
              <span class="icon-heading-title">
                <span class="title">Lagre faktura</span>
              </span>
            </h3>
          </div>
        </div>

        <div class="modal-window-body">
          <div class="grid-x grid-padding-x">
            <div class="cell medium-12">
              <h3>Selger: {{innlevav.full_name}}</h3>
            </div>
          </div>
          <div class="grid-x grid-padding-x"><div class="cell medium-12">&nbsp;</div></div>

          <div class="grid-x grid-padding-x">
            <div class="cell medium-10">
              Fakturadresse
            </div>
            <div class="cell medium-2 align-right">
              <span v-if="invoiceAddress">Ok</span>
              <span v-else>X</span>
            </div>
            <div class="cell medium-12">
              {{innlevav.full_address_fak}}
            </div>
          </div>
          <div class="grid-x grid-padding-x"><div class="cell medium-12">&nbsp;</div></div>

          <div class="grid-x grid-padding-x">
            <div class="cell medium-10">
              Leveringsadresse
            </div>
            <div class="cell medium-2 align-right">
              <span v-if="postAddress">Ok</span>
              <span v-else>X</span>
            </div>
            <div class="cell medium-12">
              {{innlevav.full_address_lev}}
            </div>
          </div>
          <div class="grid-x grid-padding-x"><div class="cell medium-12">&nbsp;</div></div>

          <template v-if="isEmptyLandKode">
            <div class="grid-x grid-padding-x">
              <div class="cell medium-10">
                Landkode
              </div>
              <div class="cell medium-2 align-right">
                <span v-if="getLandKode">Ok</span>
                <span v-else>X</span>
              </div>
              <div class="cell medium-12">
                {{getLandKode()}}
              </div>
            </div>
            <div class="grid-x grid-padding-x"><div class="cell medium-12">&nbsp;</div></div>
          </template>

          <template v-if="isForeign && !isEmptyLandKode">
            <div class="grid-x grid-padding-x">
              <div class="cell medium-10">
                IBAN
              </div>
              <div class="cell medium-2 align-right">
                <span v-if="innlevav.Iban">Ok</span>
                <span v-else>X</span>
              </div>
              <div class="cell medium-12">
                {{innlevav.Iban}}
              </div>
            </div>
            <div class="grid-x grid-padding-x"><div class="cell medium-12">&nbsp;</div></div>
            <div class="grid-x grid-padding-x">
              <div class="cell medium-10">
                SWIFT
              </div>
              <div class="cell medium-2 align-right">
                <span v-if="innlevav.Swift">Ok</span>
                <span v-else>X</span>
              </div>
              <div class="cell medium-12">
                {{innlevav.Swift}}
              </div>
            </div>
          </template>

          <template v-else>
            <div class="grid-x grid-padding-x">
              <div class="cell medium-10">
                Kontonummer
              </div>
              <div class="cell medium-2 align-right">
                <span v-if="accountNumber">Ok</span>
                <span v-else>X</span>
              </div>
              <div class="cell medium-12">
                {{innlevav.Kontonr}}
              </div>
            </div>
            <div class="grid-x grid-padding-x"><div class="cell medium-12">&nbsp;</div></div>
          </template>

          <div class="grid-x grid-padding-x">
            <div class="cell medium-12">
              <br><a href="javascript:;" @click="openKundeModal()">Rediger selger</a>
            </div>
          </div>
        </div>

        <div class="modal-window-footer">
          <div class="grid-x">
            <div class="cell align-right">
              <a v-if="!$store.getters.isFormProcessing" href="javascript:;" @click="closeButtonClick()" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
              <a v-else href="javascript:;" class="button primary transparent large modal-close show-for-medium">Avbryt</a>

              <template>
                <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="submitButtonClick()" class="button primary submit large">Lagre</a>
                <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary submit large" disabled>Lagre</a>
                <a v-if="$store.getters.isFormProcessing" href="javascript:;" class="button primary submit large loading">Lagrer...<span class="loader-spinner"></span></a>
              </template>
            </div>
          </div>
        </div>

        <a href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
          <span>Lukk</span>
          <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
        </a>
      </form>
    </overlay-scrollbars>
  </div>
</template>

<script>
// import ObjektService from '@/services/ObjektService'
import bus from '@/plugins/event-bus'
import ObjektService from '@/services/ObjektService'

export default {
  name: 'KundeKontraktObjektTabSelgerBilagDraftModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    objekt: {
      type: Object,
      required: true
    },
    objektlist: {
      type: Array,
      required: true
    }
  },
  data () {
    const today = new Date()

    return {
      innlevav: {},
      minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
      loadingKunde: false
    }
  },
  created () {
    bus.$off('kunde-address-updated')

    this.innlevav = this._.cloneDeep(this.objekt.innlevav)
  },
  mounted () {
    window.jQuery('.modal-window-body').attr('tabindex', -1).css({outline: 'none'}).focus()

    bus.$on('kunde-address-updated', (data) => this.onKundeAddressUpdated(data))
  },
  computed: {
    isEmptyLandKode: function () {
      if (!this.innlevav) {
        return true
      }

      if (this.getLandKode() === false) {
        return true
      }

      return false
    },
    isForeign: function () {
      if (!this.innlevav) {
        return false
      }

      let invoiceAddressTemp = this.getLandKode()

      return !invoiceAddressTemp || invoiceAddressTemp !== 'NO'
    },
    invoiceAddress: function () {
      if (!this.innlevav) {
        return null
      }

      if (!this.innlevav.kundeadresse || this.innlevav.kundeadresse.length < 1) {
        return null
      }

      return this.innlevav.kundeadresse.filter(i => i.Type === 'faktura')
    },
    postAddress: function () {
      if (!this.innlevav) {
        return null
      }

      if (!this.innlevav.kundeadresse || this.innlevav.kundeadresse.length < 1) {
        return null
      }

      return this.innlevav.kundeadresse.filter(i => i.Type === 'levering')
    },
    accountNumber: function () {
      if (!this.innlevav) {
        return null
      }

      if (!this.innlevav.Kontonr) {
        return null
      }

      if (!this.innlevav.Kontonr.match(/^\d+$/)) {
        return null
      }

      if (!this.innlevav.Kontonr.length === 11) {
        return null
      }

      return this.innlevav.Kontonr
    },
    isValidForSave: function () {
      // Exists
      if (!this.innlevav.Kundenr) {
        return false
      }

      // Has addresses
      if (!this.invoiceAddress || !this.postAddress) {
        return false
      }

      // Skip the account nr check...

      // if (this.isForeign) {
      //   // Foreign customer must have Iban and Swift
      //   if (!this.innlevav.Iban || !this.innlevav.Swift) {
      //     return false
      //   }
      // } else {
      //   // Norwegian customer must have accountnr
      //   if (!this.accountNumber) {
      //     return false
      //   }
      // }

      return true
    }
  },
  methods: {
    onKundeAddressUpdated: function (data) {
      this.$helpers.showSuccessAlert('Selger er lagret')

      this.innlevav = Object.assign({}, this.innlevav, data)

      let item = this._.cloneDeep(this.objekt)
      item.innlevav = Object.assign({}, item.innlevav, data)

      // Send event to root - to update kunde, as objekt->innlevav is same as kunde
      bus.$emit('kunde-merged', item.innlevav)

      // Send event to root - to update objekt
      bus.$emit('kunde-kontrakt-objekt-updated', item)
    },
    openKundeModal: function () {
      this.openModal(
        'kunde-adresse-modal',
        {
          kunde: this.objekt.innlevav,
          event: 'kunde-address-updated'
        }
      )
    },
    closeButtonClick: function () {
      if (!this.$store.getters.isFormProcessing) {
        this.$emit('close')
      }
    },
    submitButtonClick: function () {
      this.handleSubmit()
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.$helpers.showErrorAlert('Feil', 'Vennligst korriger feil')
            this.setFormProcessing(false)
          } else if (!this.isValidForSave) {
            this.$helpers.showErrorAlert('Feil', 'Vennligst korriger feil')
            this.setFormProcessing(false)
          } else {
            console.log('Do save')

            // Save here or emit event to parent, so we save there?
            let post = {
              Bilagsid: this.data.Bilagsid,
              Bilagstype: this.data.Bilagstype,
              Export: this.data.Export,
              Mvafri: this.data.Mvafri,
              Retur: this.data.Retur,
              objektlist: this.objektlist,
              type: 'draft'
            }

            console.log('TODO: Add the save method - in the draft modal')
            console.log(post)
            console.log(JSON.stringify(post))

            ObjektService.saveObjektBilagSeller(this.objekt.Objektid, post)
              .then((response) => {
                bus.$emit('seller-invoice-created-from-draft-modal', response.data)
                this.closeModal()
              })
              .catch((e) => {
                console.log('Error From API')
                console.log(e)

                const custom = this.$helpers.getCustomErrors(e)

                if (custom.objekt && custom.objekt.length > 0) {
                  this.$helpers.showErrorAlert('Feil', custom.objekt[0])
                } else {
                  this.$helpers.showErrorAlert('Feil', 'Kunne ikke lagre')
                }
              })
              .then(() => {
                this.setFormProcessing(false)
              })
          }
        })
    },
    getLandKode: function () {
      if (this.innlevav) {
        if (this.innlevav.kundeadresse && this.innlevav.kundeadresse.length > 1) {
          let [invoiceAddressTemp] = this.innlevav.kundeadresse.filter(i => i.Type === 'faktura')

          if (invoiceAddressTemp && invoiceAddressTemp.Landkode) {
            return invoiceAddressTemp.Landkode
          }
        }
      }

      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktObjektTabSelgerBilagDraftModal.vue